module.exports = __webpack_public_path__ + "static/media/bolso (11).b9e95a67.jpg";